module.exports = __webpack_public_path__ + "static/img/产品中心-Coalclaw 煤矿私有化智能助手-公文与报表自动化.f8085993.jpg";